import { Box, Flex, Grid, GridItem, Image, Input, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, FormControl, FormLabel, Button, Center, Spinner, } from '@chakra-ui/react'
import MyDiv from './attendanceSetting.style'
import { CustomButton, CustomToast, ActionEditIcon } from '../../../../components';
import { useEffect, useState } from 'react';
import PlusIcon from "../../../../assets/images/Vector.svg";
import { IAttendanceSetting } from './model';
import { useFetch } from '../../../../hooks/useFetch';
import * as yup from "yup";



const Header = [
    { id: 1, head: 'S. No' },
    { id: 2, head: 'Grace-Minute' },
    { id: 3, head: 'Half-Day-Cut-Off' },
    { id: 4, head: 'Early-Out-Minute' },
    { id: 5, head: 'Actions' },
];

const AttendanceSetting = () => {

    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const { addToast } = CustomToast();
    const { fetchApi, loading } = useFetch(addToast);
    const [attendanceSettings, setAttendanceSettings] = useState<IAttendanceSetting[]>([]); // list
    const [currentAttendanceSetting, setCurrentAttendanceSetting] = useState<IAttendanceSetting>({
        id: 0,
        grace_Minute: 0,
        half_Day_Cut_Off: 0,
        early_Out_Minute: 0
    });

    useEffect(() => {
        loadAttendanceSetting();
    }, []);

    const loadAttendanceSetting = async () => {
        const response = await fetchApi<IAttendanceSetting[]>("AttendanceSettings", "GET");
        if (response) setAttendanceSettings(response);
    };

    const handleAddNew = () => {
        setIsEditMode(false);
        setCurrentAttendanceSetting({ id: 0, grace_Minute: 0, half_Day_Cut_Off: 0, early_Out_Minute: 0
        });
        setDrawerOpen(true);
    };

    const handleEdit = (setting: IAttendanceSetting) => {
        setIsEditMode(true);
        setSelectedId(setting.id);
        setCurrentAttendanceSetting(setting);
        setDrawerOpen(true);
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setCurrentAttendanceSetting(prev => ({
            ...prev,
            [name]: Number(value)
        }));
    };
    const handleSubmit = async () => {
        if (
            currentAttendanceSetting.grace_Minute <= 0 ||
            currentAttendanceSetting.half_Day_Cut_Off <= 0 ||
            currentAttendanceSetting.early_Out_Minute <= 0
        ) {
            addToast({ message: 'Please fill all fields properly eah field should be greater than 0', status: 'warning' });
            return;
        }

        if (isEditMode && selectedId !== null) {
            const response = await fetchApi<any>(`AttendanceSettings/${selectedId}`, 'PUT', currentAttendanceSetting, null,
                'Attendance setting updated successfully'
            );
            if (response) {
                await loadAttendanceSetting();
            }
        } else {
            const response = await fetchApi<any>('AttendanceSettings', 'POST', currentAttendanceSetting, null,
                'Attendance setting added successfully'
            );
            if (response) {
                await loadAttendanceSetting();
            }
        }
        setDrawerOpen(false);
    };


    return (
        <MyDiv>
            <Box position="relative" minH="300px">
                {loading ? (
                    <Center position="absolute" top={0} left={0} right={0} bottom={0}>
                        <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
                    </Center>) : (
                    <>
                        <Flex className="page_heading flex_header" >
                            <Text className="font-poppins text_semibold text_3xl">Attendance Setting </Text>
                            <Flex gap={2}>
                                <CustomButton title="Add New Attendance Setting" className=' btn font-poppins text_sm text_medium' rightIcon={<Image src={PlusIcon} className='logo' />} onClick={handleAddNew} />
                            </Flex>
                        </Flex>
                        <Grid className='grid_container'>
                            <GridItem colSpan={12}>
                                <TableContainer mt={4} borderRadius="md" boxShadow="sm" bg="#fff" overflowX={"scroll"} w={"auto"}>
                                    <Table variant='striped' colorScheme='gray'>
                                        <Thead className="table_header">
                                            <Tr>
                                                {Header.map((data, index) => (
                                                    <Th textAlign='center' className="font-poppins text_sm text_medium" >{data.head}</Th>
                                                ))}
                                            </Tr>
                                        </Thead>
                                        <Tbody>
                                            {attendanceSettings.map((setting, index) => (
                                                <Tr key={setting.id}>
                                                    <Td className="font-poppins text_sm text_regular" textAlign="center">{index + 1}</Td>
                                                    <Td className="font-poppins text_sm text_regular" textAlign="center">{setting.grace_Minute}</Td>
                                                    <Td className="font-poppins text_sm text_regular" textAlign="center">{setting.half_Day_Cut_Off}</Td>
                                                    <Td className="font-poppins text_sm text_regular" textAlign="center">{setting.early_Out_Minute}</Td>
                                                    <Td textAlign="center">
                                                        <ActionEditIcon onClick={() => handleEdit(setting)} />
                                                    </Td>
                                                </Tr>
                                            ))}
                                        </Tbody>
                                    </Table>
                                </TableContainer>
                            </GridItem>
                        </Grid>

                        <Drawer isOpen={drawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="sm">
                            <DrawerOverlay />
                            <DrawerContent>
                                <DrawerCloseButton />
                                <DrawerHeader borderBottomWidth="1px">{isEditMode ? 'Edit Attendance Setting' : 'Add New Attendance Setting'}</DrawerHeader>
                                <DrawerBody display="flex" flexDirection="column" justifyContent="space-between" height="100%">
                                    <Box py={4}>
                                        <FormControl mb={4} isRequired>
                                            <FormLabel>Grace-Minute</FormLabel>
                                            <Input type="number" name="grace_Minute" value={currentAttendanceSetting.grace_Minute} onChange={handleInputChange} />
                                        </FormControl>

                                        <FormControl mb={4} isRequired>
                                            <FormLabel>Half-Day-Cut-Off</FormLabel>
                                            <Input type="number" name="half_Day_Cut_Off" value={currentAttendanceSetting.half_Day_Cut_Off} onChange={handleInputChange}
                                            />
                                        </FormControl>

                                        <FormControl mb={4} isRequired>
                                            <FormLabel>Early-Out-Minute</FormLabel>
                                            <Input type="number" name="early_Out_Minute" value={currentAttendanceSetting.early_Out_Minute} onChange={handleInputChange}
                                            />
                                        </FormControl>

                                    </Box>
                                    <Flex justify="flex-end" mt={4} gap={2}>
                                        <Button className="font-poppins text_sm text_medium" onClick={() => setDrawerOpen(false)} style={{ backgroundColor: '#D92F34', color: 'white' }}>Cancel</Button>
                                        <Button onClick={handleSubmit} className="font-poppins text_sm text_medium" style={{ backgroundColor: '#006838', color: 'white' }}>{isEditMode ? "Update Attendance Setting" : "Add New Attendance Setting"}</Button>
                                    </Flex>
                                </DrawerBody>
                            </DrawerContent>
                        </Drawer>
                    </>)}
            </Box>
        </MyDiv>
    )
}

export default AttendanceSetting;
